/**
 * Next URL search for opening (`taskId`) or closing (`null`) the shared task
 * modal, preserving the rest of the search — notably `space_id`. Pass it to a
 * router `navigate`'s functional `search` updater (so `prev` is the current
 * search). Replacing the whole object instead would drop `space_id`, flashing an
 * empty view and breaking copied URLs.
 */
export function taskModalSearch<T extends object>(
  prev: T,
  taskId: string | null,
): Omit<T, "task"> & { task: string | undefined } {
  return { ...prev, task: taskId ?? undefined };
}
